import { render, staticRenderFns } from "./Drunk.vue?vue&type=template&id=0bb5d65e&scoped=true&"
import script from "./Drunk.vue?vue&type=script&lang=js&"
export * from "./Drunk.vue?vue&type=script&lang=js&"
import style0 from "./Drunk.vue?vue&type=style&index=0&id=0bb5d65e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb5d65e",
  null
  
)

export default component.exports